import { debounce, throttle } from 'lodash';

const headerAll = document.querySelectorAll('.js-header');

const glossaryHeader = document.querySelector('.js-hld-glossary');

const additionalBtns = document.querySelectorAll('.site-top__links__btn');

headerAll.forEach(header => {
    const scrollOffset = 80;
    let currentScroll;
    let prevScroll = window.scrollY || document.documentElement.scrollTop;
    let prevDirection = 0;
    let direction = 0;

    const resizeBtns = () => {
        additionalBtns.forEach(btn => {
            btn.classList.add('b-btn--small');
        });
    };
    const resetBtns = () => {
        additionalBtns.forEach(btn => {
            btn.classList.remove('b-btn--small');
        });
    };

    const checkScroll = () => {
        currentScroll = window.scrollY || document.documentElement.scrollTop;
        // Find the direction of scroll:
        // 0 - initial,
        // 1 - up,
        // 2 - down

        if (currentScroll > prevScroll) {
            direction = 2;
        } else if (currentScroll <= prevScroll) {
            direction = 1;
        }

        if (direction !== prevDirection) {
            toggleHeader(direction, currentScroll);
        }
        if (currentScroll > 0) {
            header.classList.add('is-scrolled');
            if (glossaryHeader) {
                glossaryHeader.classList.add('is-scrolled');
            }
            resizeBtns();
        } else {
            header.classList.remove('is-scrolled');
            if (glossaryHeader) {
                glossaryHeader.classList.remove('is-scrolled');
            }
            resizeButtonForMobile();
        }
        prevScroll = currentScroll;
    };
    const toggleHeader = (dir, curScroll) => {
        if (dir === 2 && curScroll > scrollOffset) {
            header.classList.add('is-scrolled-down');
            if (glossaryHeader) {
                glossaryHeader.classList.add('is-scrolled-down');
            }
            prevDirection = dir;
        } else if (dir === 1) {
            header.classList.remove('is-scrolled-down');
            if (glossaryHeader) {
                glossaryHeader.classList.remove('is-scrolled-down');
            }
            prevDirection = dir;
        }
    };

    const resizeButtonForMobile = () => {
        if (window.innerWidth >= 1024) {
            resetBtns();
        } else {
            resizeBtns();
        }
    };

    window.addEventListener('scroll', throttle(checkScroll, 100));
    window.addEventListener('load', () => {
        checkScroll();
        resizeButtonForMobile();
    });
    window.addEventListener('resize', debounce( () => {
        resizeButtonForMobile();
    }, 500));
});


